import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Text, Modal } from '@simplybenefits/sb-ui-library';

class MasterSettings extends PureComponent {
    state = {
        email: '',
        access: ''
    };

    componentDidMount() {
        const { master } = this.props;

        this.setState({
            email: master.email,
            access: master.access
        });
    }

    render() {
        const { hideModal } = this.props;
        
        return (
            <Modal
                testid="master-settings-modal"
                open={true}
                onClose={hideModal}
                title="Account Settings"
                loader={ this.props.loader }
            >
                <Text
                    align="center"
                    medium
                    margin="0px 5px 0px 0px"
                    display="flex"
                    customStyle={{ letterSpacing: '0.6px', cursor: 'pointer' }}
                >
                    email: { this.state.email }
                </Text>

                <Text
                    align="center"
                    medium
                    margin="0px 5px 0px 0px"
                    display="flex"
                    customStyle={{ letterSpacing: '0.6px', cursor: 'pointer' }}
                >
                    access: { this.state.access }
                </Text>
            </Modal>
        );
    }
}

MasterSettings.propTypes = {
    master: PropTypes.object
};

/**
 *
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    loader: state.loader,
    master: state.master
});

export default connect(mapStateToProps)(MasterSettings);